import { Box } from "ui-library/layouts/Box/Box";

export const Section = ({ children, ...props }) => {
    return <Box mb={{ xs: 3, md: 6 }}>{children}</Box>;
};

Section.propTypes = {};

Section.defaultProps = {};
